/*********************************************************************************
 *	Pagination Directive
 *********************************************************************************/
(function() {
  

  angular.module('rcDirectives.pagination', []).directive(
    'rcPagination',
    /* @ngInject */
    function(DomUtility) {
      return {
        restrict: 'A',
        replace: true,
        templateUrl: 'templates/pagination.html',
        scope: {
          currentPage: '=',
          totalPages: '@',
          onPageChange: '&'
        },
        link: function(scope, element) {
          //"Cache" user input page element
          var inPage = angular.element(element[0].querySelector('.js-page-input'));

          //Holds the number in the page input so that DOM isn't interrogated each time to retrieve it.
          //Updated each time valid number is typed in.
          var pageInputValue;

          //Set the value of the page input var and DOM element
          var setPageInputValue = function(value) {
            pageInputValue = value;
            inPage.val(pageInputValue);
          };

          //Check if `page` is a valid page number
          //Valid means it is a number made up of digits from 0 to 9, larger than 0 and less or equal to total pages
          var isValidPageNumber = function(page) {
            var rxIsNumeric = /^[0-9]+$/;
            var intPage = parseInt(page, 10);
            return (
              rxIsNumeric.test(page) &&
              !isNaN(intPage) &&
              intPage > 0 &&
              intPage <= scope.totalPages
            );
          };

          //Listen for input event on the inPage element and update currentPage on valid input
          var keydownHandler = function(event) {
            var keyCode = DomUtility.getKeyCode(event);
            if (keyCode === 13) {
              //Enter key
              //Prevent default so that IE doesn't toggle sidebar instead of performing search
              //IE bug to with IE selecting the first button (type="button") it finds and triggering it on Enter key press
              event.preventDefault();

              var value = inPage.val();
              var intValue = parseInt(value, 10);
              if (scope.totalPages && scope.totalPages > 1) {
                //Wait until total pages is set and larger than 1
                if (isValidPageNumber(value)) {
                  //Accept page change if the input value is different
                  if (intValue !== pageInputValue) {
                    scope.$apply(function() {
                      setCurrentPage(intValue);
                    });
                    inPage[0].blur(); //Remove focus from input so user can't change currentPage under loading overlayer
                  }
                  inPage.removeClass('error');
                } else {
                  inPage.addClass('error');
                }
              }
            }
          };
          inPage.on('keydown', keydownHandler);

          //Change input value and remove error class if input loses focus and contains invalid page or a valid page that wasn't submitted by pressing enter
          var focusOutHandler = function() {
            var value = inPage.val(); //Current page input value
            if (!isValidPageNumber(value) || value !== scope.currentPage) {
              setPageInputValue(scope.currentPage);
              inPage.removeClass('error');
            }
          };
          inPage.on('blur', focusOutHandler);

          //Default value for currentPage
          if (!scope.currentPage) {
            scope.currentPage = 1;
          }

          //Keep inPage value and currentPage in sync
          scope.$watch('currentPage', function() {
            if (pageInputValue !== scope.currentPage) {
              setPageInputValue(scope.currentPage);
            }
          });

          //Make sure maxlength attribute of inPage is the string length of totalPages
          scope.$watch('totalPages', function() {
            inPage.attr('maxlength', ('' + scope.totalPages).length);
          });

          //Go one page back
          scope.previousPage = function() {
            var newPage = parseInt(scope.currentPage, 10) - 1;
            if (newPage > 0) {
              setCurrentPage(newPage);
            }
          };

          //Go one page forward
          scope.nextPage = function() {
            var newPage = parseInt(scope.currentPage, 10) + 1;
            if (newPage <= scope.totalPages) {
              setCurrentPage(newPage);
            }
          };

          //Update currentPage and request data for it
          var setCurrentPage = function(page) {
            scope.currentPage = page;
            scope.onPageChange({page: page});
          };

          //Clean-up
          scope.$on('$destroy', function() {
            inPage.off('blur', focusOutHandler);
            inPage.off('keydown', keydownHandler);
          });
        }
      };
    }
  );
})();
